declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, ServiceProvidersController, GetServicesRequest, GenericProcPostRequest, S_Methods, GetServiceProvidersRequest, DoctorsListController, DoctorsListRequest, SaveNewServiceProvider } from '../../../../../models/actor/actor';
import { ActorService } from '../../../../../services/actor.service';
import { DBOperation } from '../../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BillDetails } from '../../../_MasterClasses/BillingClasses';



@Component({
  selector: 'opsearchprovider',
  templateUrl: './opsearchprovider.modal.html',
  styleUrls: ['./opsearchprovider.modal.scss']
})

export class NgbOPSearchProviderModal implements OnInit {


  @Input() CurrentBillDetails: BillDetails;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  public ProviderName: string;
  public ProviderCode: number;
  public ProviderCost: number;
  public BranchPrice: number;
  public searchValue: any;
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  public NewSvcProviderCode: number;


  CurrentServiceProvidersController: ServiceProvidersController[];
  GetServiceProviders() {
    var getReq = new GetServiceProvidersRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101020;
    getReq.Branch = AppData.Instance().SelectedBranchCode;
    //alert(this.CurrentBillDetails.ItemCode);
    getReq.ServiceCode = this.CurrentBillDetails.ItemCode;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101020;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentServiceProvidersController = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;

  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    // this.pdata = this.CurrentDoctorsListController;
    //this.pdata1 = this.CurrentDoctorsListController;
    this.CurrentDoctorsListRequest.ConditionalOperator = 20;
    this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentDoctorsListController = this.ApiResData.Result;          
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  onChange(Event: any) {
    //alert(Event.value);
    if (Event != null && this.CurrentDoctorsListController.length > 0) {
      var a = this.CurrentDoctorsListController.filter(X => X.ProviderCode == Event.value)
      if (a.length > 0) {
        //this.CurrentPrescribingDoctor = null;
        //this.CurrentReferringDoctor = null;
        //this.Prescribername = a[0].DisplayName;
        
        //alert(this.NewSvcProviderCode);
        //alert(this.CurrentServiceProvidersController[0].ProviderCode);
        if (
          this.CurrentServiceProvidersController != null && 
          this.CurrentServiceProvidersController.length > 0) {
          if (this.CurrentServiceProvidersController
            .filter(x => x.PrCode == Event.value).length > 0
          ) {

            this.NewSvcProviderCode = this.CurrentServiceProvidersController
              .filter(x => x.PrCode == Event.value)[0].ProviderCode;

            this.CurrentSaveNewServiceProvider.Price =
              this.CurrentServiceProvidersController
                .filter(x => x.PrCode == Event.value)[0].ProviderCost;

            this.CurrentSaveNewServiceProvider.CommissionAmount =
              this.CurrentServiceProvidersController
                .filter(x => x.PrCode == Event.value)[0].CommissionAmount;


            // show update button
            this.CanUpdate = true;
            this.CanSave = false;
            // then refresh
            //this.GetServiceProviders();
          }
          else {
            this.NewSvcProviderCode = Event.value;
            this.CurrentSaveNewServiceProvider.Price = this.CurrentBillDetails.UnitPrice;
            this.CurrentSaveNewServiceProvider.CommissionAmount = 0;
            this.CanSave = true;
            this.CanUpdate = false;
            // save button
            //this.AddNewProvider();

          }

        } else {
          this.NewSvcProviderCode = Event.value;
          this.CurrentSaveNewServiceProvider.Price = this.CurrentBillDetails.UnitPrice;
          this.CurrentSaveNewServiceProvider.CommissionAmount = 0;
          this.CanSave = true;
          this.CanUpdate = false;
        }
        //this.Prescriberdesg = a[0].Specialty;
        //this.LoadDoctorPres();
        //this.LoadDoctorRef();

      }
    }
    else {
      //alert('svc prov not mapped to this service...!')

      //this.NewSvcProviderCode = Event.value;
      //this.CurrentSaveNewServiceProvider.Price = this.CurrentBillDetails.UnitPrice;
      //this.CurrentSaveNewServiceProvider.CommissionAmount = 0;
      //this.CanSave = true;
      //this.CanUpdate = false;

      // save button
      //this.AddNewProvider();

    }
  }

  @ViewChild('f') IdentitiesDocForm: NgForm;
  CurrentSaveNewServiceProvider: SaveNewServiceProvider;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {
    this.GetServiceProviders();
    this.LoadDoctorsList();
    this.CurrentSaveNewServiceProvider = new SaveNewServiceProvider();
    this.CurrentSaveNewServiceProvider.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }

  CanSave: boolean;
  CanUpdate: boolean;
  AddNewProvider() {
    var saveReq = new SaveNewServiceProvider();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40152;
    saveReq.BranchCode = AppData.Instance().SelectedBranchCode;
    saveReq.ProviderCode = this.NewSvcProviderCode;
    saveReq.ServiceCode = this.CurrentBillDetails.ItemCode;
    saveReq.Price = this.CurrentSaveNewServiceProvider.Price;
    saveReq.OpType = 'Save';
    saveReq.CommissionAmount = this.CurrentSaveNewServiceProvider.CommissionAmount;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40152;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            // then refresh
            this.GetServiceProviders();
            //this.activeModal.close();
          //}
          //else {
            //alertFunctions.AlertParam("Invalid Operation...!");
            //this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  UpdateProvider() {
    var saveReq = new SaveNewServiceProvider();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 40152;
    saveReq.BranchCode = AppData.Instance().SelectedBranchCode;
    saveReq.ProviderCode = this.NewSvcProviderCode;
    saveReq.ServiceCode = this.CurrentBillDetails.ItemCode;
    saveReq.Price = this.CurrentSaveNewServiceProvider.Price;
    saveReq.CommissionAmount = this.CurrentSaveNewServiceProvider.CommissionAmount;
    saveReq.OpType = 'Update';
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 40152;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            // then refresh
            this.GetServiceProviders();
            //this.activeModal.close();
          //}
          //else {
          //  alertFunctions.AlertParam("Invalid Operation...!");
          //  this.stopRefreshing();
          //}
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  ProviderDetails(l: ServiceProvidersController) {
    this.ProviderName = l.ProviderName;
    this.ProviderCode = l.ProviderCode;
    this.ProviderCost = l.ProviderCost;
    this.BranchPrice = l.BranchPrice;
    this.passEntry.emit({
      make: this.ProviderName, value: this.ProviderCode, number: this.ProviderCost,
      branchprice: this.BranchPrice
    }
    );
    this.activeModal.dismiss('Cross click');
  }
  criteriaChange(value: string) {

  }

  ClearInput() {

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  editfollicular() {
    this.router.navigate(['nurse/editfollicular']);
    this.activeModal.close();
  }
}

